import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { observer } from 'mobx-react';
import Icon from '../../../../components/Icon';
import IconButton from '../../../../components/IconButton';
import { Dropdown, DropdownItem, DropdownItemIcon } from '../../../../components/Dropdown';
import { BillingItem, Label, Content, Title, Description, Actions, ItemIcon } from '../../BillingItem';
// import styles from './PayoutMethodItem.m.sass'

var PayoutMethodItem = function PayoutMethodItem(_ref) {
  var method = _ref.method,
    onClick = _ref.onClick,
    billingStore = _ref.billingStore,
    allowEdit = _ref.allowEdit;
  var busy = billingStore.busy;
  var disabled = busy || !allowEdit;
  return /*#__PURE__*/React.createElement(BillingItem, {
    disabled: disabled,
    onClick: onClick
  }, renderContentForMethod(method), method.default ? /*#__PURE__*/React.createElement(Label, null, "Current") : /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(Dropdown, {
    position: "right",
    button: function button(buttonProps) {
      return /*#__PURE__*/React.createElement(IconButton, _extends({
        disabled: disabled
      }, buttonProps), /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "more vert"
      }));
    }
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    disabled: !allowEdit,
    onClick: function onClick(e) {
      return e.stopPropagation() || allowEdit && billingStore.deletePayoutMethod(method);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    small: true,
    material: true,
    name: "delete"
  })), "Delete"))));
};
export default observer(PayoutMethodItem);
function renderContentForMethod(method) {
  switch (method.type) {
    case 'Stripe':
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "credit card"
      })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("strong", null, "Stripe")), /*#__PURE__*/React.createElement(Description, null, "Payout via Stripe")));
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, "Unknown billing payout type \"", method.type, "\""), /*#__PURE__*/React.createElement(Description, null, "Not sure what this is.")));
  }
}
//# sourceMappingURL=index.js.map
